/* globals _, angular */
(function () {
  "use strict";

  function IntegrationConfigCtrl(
    $q,
    $state,
    $stateParams,
    $uibModal,
    $mdToast,
    IntegrationService,
    ShippingConfig,
    PROVIDERS,
    localStorageService
  ) {
    var ctrl = this;
    var provider = IntegrationService.getProvider($stateParams.provider);
    var originalStatus;

    ctrl.matches = {};
    ctrl.data = {};
    ctrl.removedMatchIds = [];
    ctrl.errors = {};

    function getOrderStatus() {
      ctrl.isStatusLoading = true;
      IntegrationService.getOrderStatus(provider.slug).then(
        function (data) {
          if (data.error) {
            console.log(
              "Order status error:",
              data.error.message,
              provider.slug
            );
            return;
          }
          ctrl.isStatusLoading = false;
          originalStatus = data.selecionado;
          ctrl.orderStatus = originalStatus;
          ctrl.statusSelector = data.disponiveis;
          var order = _.filter(ctrl.statusSelector, {
            codigo: ctrl.orderStatus.codigo,
          });
          if (order.length === 0) {
            ctrl.statusSelector.push(ctrl.orderStatus);
          }
          if (data.permiteStatusPersonalizado) {
            ctrl.statusSelector.push({
              codigo: "custom",
              descricao: "Definir status personalizado...",
            });
          }
        },
        function () {
          console.log("Order status API error");
          ctrl.isStatusLoading = false;
          ctrl.statusSelector = [];
        }
      );
    }

    function getMatches() {
      IntegrationService.getAutoDeliveryType(provider.slug)
        .then(function (data) {
          _.forEach(data.dePara, function (obj) {
            if (ctrl.matches[obj.para]) {
              ctrl.matches[obj.para].push(obj);
            }
          });
        })
        .catch(function () {
          console.log("Error: get matches");
        });
    }

    function getAutoInsurance() {
      IntegrationService.getAutoInsurance(provider.slug)
        .then(function (data) {
          ctrl.data.insurance = {
            automatic: data.preencherValorDeclarado,
            minValue: data.valorMinimoDeclarado,
            allOccasions: data.preencherTodosEnvios,
          };
        })
        .catch(function () {
          console.log("Error: get matches");
        });
    }

    function getFlagVTEX() {
      IntegrationService.getSequenceVTEX(provider.slug)
        .then((data) => {
          ctrl.data.mapeiaSequenceNoCampoReferencia =
            data.mapeiaSequenceNoCampoReferencia;
        })
        .catch(function () {
          showAlert("Oops... Não foi possível definir a importação");
          console.log("Error: get matches");
        });
    }

    function getFlagTiny() {
      IntegrationService.getConfigs(
        localStorageService.get("user").id,
        provider.slug
      )
        .then((data) => {
          ctrl.data.IMPORTACAO_AUTOMATICA_PEDIDOS =
            data.IMPORTACAO_AUTOMATICA_PEDIDOS;
        })
        .catch(function (error) {
          showAlert("Oops... Não foi possível definir a importação");
          console.log("Error: get matches", error);
        });
    }

    ctrl.$onInit = function () {
      ctrl.showCustomStatus = false;
      ctrl.orderStatus = null;
      ctrl.statusSelector = [];
      ctrl.providerConfig = angular.copy(provider);
      ShippingConfig.getOptions()
        .then(function (data) {
          ctrl.deliveryOptions = data;
          _.forEach(ctrl.deliveryOptions, function (d) {
            ctrl.matches[d.servicoEnvio] = [];
          });
          getMatches();
        })
        .catch(function () {
          console.log("Error: integration config delivery opts");
        });
      getOrderStatus();

      getAutoInsurance();

      if (provider.slug === "vtex") {
        getFlagVTEX();
      }

      if (provider.slug === "tinyerp") {
        getFlagTiny();
      }
    };

    ctrl.onStatusChange = function () {
      if (ctrl.orderStatus.codigo === "custom") {
        ctrl.showCustomStatus = true;
      }
    };

    ctrl.cancelCustomStatus = function () {
      ctrl.showCustomStatus = false;
      ctrl.orderStatus = originalStatus;
    };

    ctrl.showSettings = function (providerSlug, feature) {
      return _.find(PROVIDERS, { slug: providerSlug }).config[feature];
    };

    function getNewMatches() {
      var matches = [];
      _.forEach(ctrl.matches, function (values) {
        _.forEach(_.reject(values, "id"), function (v) {
          matches.push(v);
        });
      });
      return matches;
    }

    function isDuplicated(chip) {
      return (
        _.reduce(
          ctrl.matches,
          function (result, value) {
            var match = _.find(value, function (obj) {
              return obj.de.toLowerCase() === chip.toLowerCase();
            });
            if (match) {
              result.push(match.de);
            }
            return result;
          },
          []
        ).length > 0
      );
    }

    ctrl.addMatch = function (chip, code) {
      ctrl.errors[code] = false;
      if (isDuplicated(chip)) {
        ctrl.errors[code] = true;
        return null;
      }
      return {
        de: chip,
        para: code,
      };
    };

    ctrl.onMatchRemove = function (chip) {
      if (chip.id) {
        ctrl.removedMatchIds.push(chip.id);
      }
    };

    ctrl.showConfirm = function (evt, form) {
      evt.preventDefault();
      if (!form.$dirty) {
        $state.go("integration");
        return;
      }
      var modalInstance = $uibModal.open({
        template: require("./confirmation-modal/confirmation-modal.html"),
        controllerAs: "$ctrl",
        controller: [
          "$uibModalInstance",
          function ($uibModalInstance) {
            var ctrl = this;
            ctrl.ok = function () {
              $uibModalInstance.close();
            };
            ctrl.cancel = function () {
              $uibModalInstance.dismiss();
            };
          },
        ],
      });
      modalInstance.result.then(function () {
        $state.go("integration");
      });
    };

    ctrl.onSubmit = function (form) {
      if (form.$invalid) {
        return;
      }
      ctrl.isFormLoading = true;
      var successCallback = function () {
        ctrl.isFormLoading = false;
        $state.go("integration", {
          showAlert: true,
        });
      };
      var xhrs = [];
      var slug = ctrl.providerConfig.slug;
      var deliveryMatches = getNewMatches();
      if (deliveryMatches.length > 0) {
        var autoDeliveryPromise = IntegrationService.saveAutoDeliveryType(
          slug,
          deliveryMatches
        );
        xhrs.push(autoDeliveryPromise);
      }

      if (form.mapeiaSequenceNoCampoReferencia) {
        var mapeiaSequenceNoCampoReferencia =
          IntegrationService.defineSequenceVTEX(
            slug,
            form.mapeiaSequenceNoCampoReferencia.$modelValue
          );
        xhrs.push(mapeiaSequenceNoCampoReferencia);
      }

      if (form.IMPORTACAO_AUTOMATICA_PEDIDOS) {
        let data = {
          plataforma: slug,
          codigo: "IMPORTACAO_AUTOMATICA_PEDIDOS",
          ativo: form.IMPORTACAO_AUTOMATICA_PEDIDOS.$modelValue,
          cliente_fk: localStorageService.get("user").id,
        };

        var importacaoAutomaticaPromise =
          IntegrationService.defineConfigs(data);
        xhrs.push(importacaoAutomaticaPromise);
      }

      if (ctrl.removedMatchIds.length > 0) {
        var removedMatchesPromise = IntegrationService.removeAutoDeliveryType(
          slug,
          ctrl.removedMatchIds
        );
        xhrs.push(removedMatchesPromise);
      }
      if (form.orderStatus.$dirty) {
        var statusCode;
        if (form.customOrderStatus) {
          statusCode = form.customOrderStatus.$modelValue;
        } else {
          statusCode = form.orderStatus.$modelValue.codigo;
        }
        var statusPromise = IntegrationService.setOrderStatus(slug, statusCode);
        xhrs.push(statusPromise);
      }
      if (
        form.insuranceAutomatic.$dirty ||
        form.insuranceMinValue.$dirty ||
        form.insuranceAllOccasions.$dirty
      ) {
        var insurance = {
          preencherValorDeclarado: form.insuranceAutomatic.$modelValue,
          valorMinimoDeclarado: form.insuranceMinValue.$modelValue,
          preencherTodosEnvios: form.insuranceAllOccasions.$modelValue,
        };
        var insurancePromise = IntegrationService.saveAutoInsurance(
          slug,
          insurance
        );
        xhrs.push(insurancePromise);
      }
      if (xhrs.length === 0) {
        successCallback();
        return;
      }
      $q.all(xhrs)
        .then(function () {
          successCallback();
        })
        .catch(function (error) {
          ctrl.isFormLoading = false;
          showAlert("Oops... Não foi possível definir a importação");
        });
    };

    function showAlert(content) {
      var toast = $mdToast
        .simple()
        .textContent(content)
        .highlightAction(true)
        .parent('[data-container="toast"]')
        .position("top right")
        .hideDelay(5000);

      return $mdToast.show(toast);
    }
  }

  angular
    .module("mandaeApp")
    .controller("IntegrationConfigCtrl", IntegrationConfigCtrl);
})();
